<template>
  <containElement>
  </containElement>
</template>

<script>
import containElement from '@/components/Container.vue'
import { getObjFromUrl } from '@/utils'
import { getNameById } from '@/api/baseInfo'
import { getBrands } from '@/api/search'
import ErrorStackParser from 'error-stack-parser'
import { getBaseErrorObj } from '@/utils/index.js'
import { clientError } from '@/api/public'
export default {
  components: { containElement },
  /*computed: {
    searchParam() {
      return getObjFromUrl(window.location.href)
    },
  },*/
  methods: {
    //根据ID获取名称，适用于将地址直接输入到浏览器（尤其是未经过页面选择方式设置参数而是直接读取浏览器地址栏参数的跨域浏览器）中回车时，解决相关名称回显问题
    getDefaultNameData() {
      let brand_id = this.$store.state.user.selectedType
        ? this.$store.state.user.selectedType.join(',')
        : ''
      let param = { brand_id: brand_id, kol_id: this.$store.state.user.KolId }
      getNameById(param)
        .then((res) => {
          if (res.status == 'ok') {
            let data = res.result.data
            if (data.kol && data.kol.length > 0) {
              this.$store.dispatch('user/changeKolName', data.kol[0].kol_name)
              localStorage.setItem('kol_name', data.kol[0].kol_name)
            } else if (data.brand && data.brand.length > 0) {
              this.$store.dispatch('user/changeBrandName', data.brand)
              localStorage.setItem('brandName', JSON.stringify(data.brand))
            }
          }
        })
        .catch((e) => {})
    },
    //查询默认的十个品牌
    getDefaultBrandOptions() {
      let param = { brand_name: '' }
      getBrands(param).then((res) => {
        if (res.status == 'ok') {
          localStorage.setItem(
            'defaultBrandOption',
            JSON.stringify(res.result.data)
          )
        }
      })
    },
    chageFavicon() {
      if (this.$store.state.user.loginInfo.is_partner) {
        if (this.$store.state.user.loginInfo.partner_title) {
          document.title = this.$store.state.user.loginInfo.partner_title
        }
        let favicon = document.querySelector("link[rel~='icon']")
        if (this.$store.state.user.loginInfo.partner_logo_url) {
          favicon.href = this.$store.state.user.loginInfo.partner_logo_url
        } else {
          favicon.href = './not.png'
        }
      }
    },
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        var arr = []
        if (window.location.href.includes('/ebayDetail')) {
          return false
        }
        let param_val = getObjFromUrl(window.location.href)
        localStorage.setItem('ActivedTabArr', arr)
        if (param_val.bName != undefined && param_val.bName != '') {
          this.$store.dispatch(
            'user/changeBrandName',
            decodeURIComponent(param_val.bName)
          )
        } else {
          // 没传brandName,修改brandName为null
          this.$store.dispatch('user/changeBrandName', null)
        }
        if (param_val.word != undefined && param_val.word != '') {
          let val = decodeURIComponent(param_val.word).replace(
            new RegExp('&amp;', 'g'),
            '&'
          )
          this.$store.dispatch('user/changeSelectedKeyWards', val)
          localStorage.setItem('word', val)
        }
        if (param_val.ts != undefined && param_val.ts) {
          this.$store.dispatch(
            'user/changeTs',
            decodeURIComponent(param_val.ts)
          )
          localStorage.setItem('ts', decodeURIComponent(param_val.ts))
        }
        if (param_val.cName != undefined) {
          this.$store.dispatch(
            'user/changeCatName',
            decodeURIComponent(param_val.cName)
          )
          localStorage.setItem('cName', decodeURIComponent(param_val.cName))
        }
        if (param_val.start != undefined) {
          this.$store.dispatch(
            'user/changeStartMonth',
            decodeURIComponent(param_val.start)
          )
        }
        if (param_val.end != undefined) {
          this.$store.dispatch(
            'user/changeEndMonth',
            decodeURIComponent(param_val.end)
          )
        }
        if (param_val.CloudWord != undefined) {
          this.$store.dispatch(
            'user/changeCloudWord',
            decodeURIComponent(param_val.CloudWord)
          )
        }
      },
      immediate: true,
    },
    '$store.state.user.catsInfo': {
      handler(newVal, oldVal) {
        let arr = []
        let param_val = getObjFromUrl(window.location.href)
        if (
          newVal.childrenList[param_val.cid] &&
          !newVal.childrenList[param_val.cid].is_parent
        ) {
          arr.push(1)
          this.$store.dispatch('user/changeActivedTabArr', arr)
        }

        if (param_val.bid != undefined && param_val.bid != '') {
          arr.push(2)
          this.$store.dispatch(
            'user/changeBrandId',
            decodeURIComponent(param_val.bid)
          )
          this.$store.dispatch('user/changeActivedTabArr', arr)
        }
      },
      deep: true,
    },
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        this.chageFavicon()
      },
    },
  },
  created() {
    this.chageFavicon()
    window.onerror = function (message, url, lineNumber, columnNumber, error) {
      // console.error(
      //   'Error: ' + message + '\nURL: ' + url + '\nLine Number: ' + lineNumber
      // )
      const parsedError = ErrorStackParser.parse(error)
      const baseObj = getBaseErrorObj()
      baseObj.error_msg = message
      baseObj.stackTrace = parsedError
      clientError(baseObj)
      return true // 阻止浏览器默认行为
    }
  },
}
</script>

<style>
</style>
